import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useCardStyle = makeStyles((theme: Theme) => ({
  paper: {
    padding: 0,
  },
  container: {
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  hidden: {
    display: 'none',
  },
}));
